export const HYDRATION_STANDARD_SCROLL_BUFFER = 750;
export const CAROUSEL_HYDRATION_STANDARD_SCROLL_BUFFER = 1500;
export const HYDRATION_STANDARD_DELAY_TIMER = 1500;
export const PLP_PAGE = 'plppage';
export const TOOL_RENTAL = 'Tool Rental';
export const ONLINE_STORE_ID = '8119';

// BrowseAndSearch
export const PRODUCT_POD_COUNT = {
  CLIENT: 24,
  SERVER: 12,
};
export const MAX_PODS_TO_HYDRATE = {
  DESKTOP: 12,
  MOBILE: 6,
};
export const CATEGORY_CARD_POSITION_INDEX = 12;

// Recommendation requestKey
export const RECS_REQUEST_KEY = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';

export const STICKY_HEADER_HEIGHT = {
  MOBILE: 59,
  DESKTOP: 114,
};

// differentiates request calls between recs containers
// TODO: Update if necessary with new values for Major Appliance
export const requestKey = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';
export const AVATAAR_AUGMENTED_REALITY_IDS_TNT = [
  '312275136', '312284218', '312285981', '312439629', '312439700', '312440061', '312440202', '303516040', '320119641',
  '312440282', '312440605', '312441660', '312563953', '312903023', '313001380', '312751609', '312758394', '318100023',
  '313803342', '314024386', '314103811', '312285857', '312286019', '314755122', '319857211', '320026646', '303516039',
  '321774731', '321887244', '313846237', '318268649', '320326878', '315868139', '316091585', '316393269', '319923566',
  '312440135', '313550124', '314103818', '314145556', '314312330', '317914041', '317989076', '318069436', '315879068',
  '314744262', '315750223', '315868404', '315949991', '315972136', '317013047', '319615744', '319615868', '318268534',
  '317436989', '317445728', '317821963', '317843042', '318100083', '319615947', '315868024', '318304558', '319503107',
  '320119258', '320326726', '320326746', '320484893', '320690384', '321253238', '206355460', '316391992', '313846213',
  '317436954', '320119266', '317989080', '312450168', '320020843', '319502657', '319696043', '320326840', '320612278',
  '312284270', '312285899', '315423281', '317013048', '315879054', '321774705', '314312141', '319615861', '319503087',
  '315868429', '316758363', '317436804', '317445512', '317450098', '317612685', '317651326', '317651351', '317651467',
  '317914032', '320587744', '317842096', '319615951', '320326920', '321151188', '320061862', '322117741', '314024432',
  '319923732', '315845275', '313489925', '315423162', '319857128'
];
